import { call, options, params } from './helpers';

export const getServices = (payload) =>
	call(`/beta/services${params(payload)}`);

export const addService = (payload) =>
	call(`/beta/services`, options(payload, 'POST'));

export const getService = ({ id }) => call(`/beta/services/${id}`);
export const updateService = ({ id, ...payload }) =>
	call(`/beta/services/${id}`, options(payload, 'PUT'));

export const deleteService = ({ id }) =>
	call(`/beta/services/${id}`, options(null, 'DELETE'));

export const createSingleServiceData = ({ id, ...payload }) =>
	call(`/beta/services/${id}/data`, options(payload, 'POST'));

export const updateSingleServiceData = ({ id, attributeId, ...payload }) =>
	call(`/beta/services/${id}/data/${attributeId}`, options(payload, 'PUT'));

export const deleteSingleServiceData = ({ id, attributeId, ...payload }) =>
	call(`/beta/services/${id}/data/${attributeId}`, options(payload, 'DELETE'));

export const pauseTask = ({ id, nextEventId }) =>
	call(`/beta/services/${id}/pause`, options({ nextEventId }, 'PATCH'));

export const completeTask = ({ id, ...payload }) =>
	call(`/beta/services/${id}/complete`, options(payload, 'PATCH'));

export const createEventForTask = ({ id, ...payload }) =>
	call(`/beta/services/${id}/events`, options(payload, 'POST'));

export const updateEventForTask = ({ id, eventId, ...payload }) =>
	call(`/beta/services/${id}/events/${eventId}`, options(payload, 'PATCH'));

export const deleteEventForTask = ({ id, eventId }) =>
	call(`/beta/services/${id}/events/${eventId}`, options(null, 'DELETE'));

export const removeDocumentFromTask = ({ id, documentId }) =>
	call(`/beta/services/${id}/document/${documentId}`, options(null, 'DELETE'));

export const uploadDocumentToTask = ({ id, ...payload }) =>
	call(`/beta/services/${id}/documents`, options(payload, 'PATCH'));

export const addAssetToTask = ({ id, assetId }) =>
	call(
		`/beta/services/${id}/addAsset?assetId=${assetId}`,
		options(null, 'PATCH')
	);

export const removeAssetFromTask = ({ id, assetId }) =>
	call(
		`/beta/services/${id}/removeAsset?assetId=${assetId}`,
		options(null, 'PATCH')
	);
